module.exports = __webpack_public_path__ + "static/media/delong.a8f4b8a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/delong.mp4
// module id = IFFq
// module chunks = 0